import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  ", ";\n  ", ";\n\n  input[type='checkbox'] {\n    clip: rect(0 0 0 0);\n    position: absolute;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0;\n    border: 0;\n    white-space: nowrap;\n\n    &:focus {\n      + svg {\n        outline: 2px solid Highlight;\n      }\n    }\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { colors } from '@vds-core/theme';
var propTypes = {
  disabled: PropTypes.bool,

  /**
   * @ignore
   * Boolean that determines if a new focus state is provided
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   * String that represents typescale of error text
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * Object containing styles of error text
   */
  bodyConfig: PropTypes.object
};
var defaultProps = {
  disabled: false,
  bodyConfig: BodyConfig,
  typescale: TypographyConfig.getTypescale()
};
/**
 * @ignore
 */

var CheckboxLabelWrapper = /*#__PURE__*/styled.label.withConfig({
  displayName: "CheckboxLabelWrapper",
  componentId: "sc-1u0cpog-0"
})(_templateObject(), function (_ref) {
  var labelText = _ref.labelText;
  return calculateRem(labelText.lineHeight);
}, function (_ref2) {
  var labelText = _ref2.labelText;
  return calculateRem(labelText.fontSize);
}, function (_ref3) {
  var labelText = _ref3.labelText;
  return labelText.fontFamily;
}, function (_ref4) {
  var labelText = _ref4.labelText;
  return calculateRem(labelText.letterSpacing);
}, function (_ref5) {
  var hitAreaLabelMargin = _ref5.hitAreaLabelMargin,
      errored = _ref5.errored;
  return hitAreaLabelMargin && errored && "\n  margin-bottom: 9px; //8px + 1px additonal border outside aligned\n  ";
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && "\n    color: ".concat(colors.coolGray3, ";\n    cursor: default;\n  ");
}, function (_ref7) {
  var focusState = _ref7.focusState;
  return focusState && "\n      &:focus {\n        outline: none;\n        + svg {\n          outline: none;\n        }\n        &:not(:hover):not(:visited):not(:active) + span {\n          &::after {\n            background: transparent;\n            border: ".concat(calculateRem(1), " dashed ").concat(colors.black, ";\n            box-sizing: border-box;\n            content: '';\n            height: 25px;\n            left: 50%;\n            position: absolute;\n            top: 50%;\n            transform: translate(-50%, -50%);\n            width: 25px;\n          }\n        }\n      }\n      ");
});

var CheckboxLabel = function CheckboxLabel(props) {
  var bodyConfig = props.bodyConfig,
      typescale = props.typescale;
  var labelText = bodyConfig.getStyles(typescale, 'desktop', typescale === 'VDS' ? 'large' : 'medium');
  return /*#__PURE__*/React.createElement(CheckboxLabelWrapper, _extends({}, props, {
    labelText: labelText,
    disabled: props.disabled,
    focusState: props.focusState
  }));
};

CheckboxLabel.propTypes = propTypes;
CheckboxLabel.defaultProps = defaultProps;
export default CheckboxLabel;